<template>
  <el-dialog
    width="420px"
    title="发放红包二维码"
    :visible.sync="visible"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div class="qrcode-container">
      <img v-if="qrcodeUrl" :src="qrcodeUrl" class="qrcode-image" alt="红包二维码" />
      <div v-else class="qrcode-placeholder">二维码生成中...</div>
      <div class="qrcode-tip">请使用微信扫一扫进行红包发放</div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="visible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "RedPacketQrcodeDialog",
  data() {
    return {
      visible: false,
      qrcodeUrl: "",
      loading: false,
    };
  },
  methods: {
    async open() {
      if (this.loading) {
        return;
      }
      this.visible = true;
      this.loading = true;
      this.qrcodeUrl = "";
      try {
        const res = await this.$api.wrpCreateQrcode({
          path: "pagesB/userUse/redPacket/index",
          appId: '1001',//测试1001，正式888 请勿随意更改
        });
        if (res) {
          this.qrcodeUrl = res;
        } else {
          this.$message.error("二维码生成失败");
          this.visible = false;
        }
      } catch (error) {
        this.$message.error("二维码生成失败");
        this.visible = false;
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      this.qrcodeUrl = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.qrcode-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0 0;
}

.qrcode-image,
.qrcode-placeholder {
  width: 220px;
  height: 220px;
  border: 1px solid #ebeef5;
}

.qrcode-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 13px;
}

.qrcode-tip {
  margin-top: 12px;
  color: #606266;
  font-size: 13px;
}
</style>
